import { render, staticRenderFns } from "./interviewReplyDetail.vue?vue&type=template&id=0f6bbfe2&scoped=true&"
import script from "./interviewReplyDetail.vue?vue&type=script&lang=js&"
export * from "./interviewReplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./interviewReplyDetail.vue?vue&type=style&index=0&id=0f6bbfe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6bbfe2",
  null
  
)

export default component.exports